export enum DegreeCode {
  HighSchoolDiploma = 'HSDIPL',
  CareerDiploma = 'CARDIPL',
  CareerCertificate = 'CARCERT',
  BachelorOfScienceDegree = 'BSDEG',
  AssociateOfScienceDegree = 'ASDEG',
  AssociateAppliedScienceDegree = 'AASDEG',
  CollegeUndergraduateCertificate = 'UGCERT',
}
